import React from 'react';

export interface ModuleTab<T extends string> {
  id: T;
  name: string;
  icon: React.ElementType;
  badge?: string;
}

interface ModuleHeaderProps<T extends string> {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon: React.ElementType;
  tabs: ModuleTab<T>[];
  active: T;
  onChange: (id: T) => void;
  actions?: React.ReactNode;
}

/** En-tête commun des modules à onglets (Caisse, Stock, Dépenses, Comptabilité…). */
function ModuleHeader<T extends string>({ title, subtitle, icon: Icon, tabs, active, onChange, actions }: ModuleHeaderProps<T>) {
  return (
    <div className="space-y-4">
      <div className="son-page-head">
        <div className="flex items-center gap-3">
          <div className="stat-icon-teal !h-11 !w-11">
            <Icon className="h-5 w-5" aria-hidden />
          </div>
          <div>
            <h1 className="son-h1">{title}</h1>
            {subtitle && <p className="son-sub !mt-0.5">{subtitle}</p>}
          </div>
        </div>
        {actions}
      </div>
      <div className="son-tabs" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={active === tab.id}
            onClick={() => onChange(tab.id)}
            className={`son-tab ${active === tab.id ? 'active' : ''}`}
          >
            <tab.icon className="h-4 w-4" aria-hidden />
            {tab.name}
            {tab.badge && <span className="son-chip son-chip-amber !text-[10.5px] !py-0">{tab.badge}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ModuleHeader;
